/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Reviews_EyebrowInputs */

const es_landing_reviews_eyebrow = /** @type {(inputs: Landing_Reviews_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opiniones`)
};

const gl_landing_reviews_eyebrow = /** @type {(inputs: Landing_Reviews_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opinións`)
};

const en_landing_reviews_eyebrow = /** @type {(inputs: Landing_Reviews_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviews`)
};

/**
* | output |
* | --- |
* | "Reviews" |
*
* @param {Landing_Reviews_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_reviews_eyebrow = /** @type {((inputs?: Landing_Reviews_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Reviews_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_reviews_eyebrow(inputs)
	if (locale === "en") return en_landing_reviews_eyebrow(inputs)
	return es_landing_reviews_eyebrow(inputs)
});